// namespace (소문자)
export const NAMESPACE = 'search';

// actions
export const FETCH_SEARCH = 'FETCH_SEARCH';
export const FETCH_SEARCH_KEYWORDS = 'FETCH_SEARCH_KEYWORDS';

// mutations

// getters
